module.exports = __webpack_public_path__ + "assets/img/naver_1399.8c6aa90f.png";